export const scrollToTops = () => {
// scroll to top
  const scrollTop = document.getElementById('js-top')
  window.onscroll = () => {
    if ((window.scrollY > 150)) {
      scrollTop.style.visibility = 'visible';
      scrollTop.style.opacity = 1;
    } else {
      scrollTop.style.visibility = 'hidden';
      scrollTop.style.opacity = 0;
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/scroll-to-top.js